import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentLanguage } from "../../../redux/selectors/languageSelectors";
import { selectCurrentBook } from "../../../redux/selectors/bookSelectors";
import { selectCurrentSentences } from "../../../redux/selectors/sentenceSelectors";
import {
  selectCurrentChapter,
  selectFilters,
  selectSyncChapters,
} from "../../../redux/selectors/filterSelectors";
import ChapterSelect from "./chapter-select";
import AfricanOnlyInput from "./form-items/african-only-input";
import { selectHasPaid } from "../../../redux/selectors/hasPaidSelectors";
import SentenceCard from "./sentence-card";
import { updateChapter as updateChapterAction } from "../../../redux/slices/filterSlice";

function SentencesDisplay({ language, idx, audioRef }) {
  const dispatch = useDispatch();

  const hasPaid = useSelector(selectHasPaid);

  const syncChapters = useSelector(selectSyncChapters);

  const currentLangauge = useSelector(selectCurrentLanguage(language));

  const currentBook = useSelector(selectCurrentBook(currentLangauge?.id));

  const currentChapter = useSelector(selectCurrentChapter(currentBook?.id));

  const { searchQuery, itemsPerPage } = useSelector(selectFilters);

  const currentSentences = useSelector(
    selectCurrentSentences(
      currentBook?.id,
      currentChapter?.chapter_id,
      itemsPerPage
    )
  );

  const currentChapterId = useSelector(selectCurrentChapter(currentBook?.id));

  const chapterSelectProps = currentBook
    ? {
        defaultValue: searchQuery.length
          ? currentSentences[0]?.chapter_id
          : currentChapterId?.chapter_id || currentSentences[0]?.chapter_id,
        hasPaid,
        chapters: currentBook.chapters,
        onChapterChange: (chapterId) =>
          dispatch(
            updateChapterAction({
              book_id: currentBook?.id,
              chapter_id: chapterId,
              syncChapters,
            })
          ),
      }
    : null;

  return (
    <div className="flex flex-col gap-2 lg:gap-4">
      {!syncChapters && currentBook && (
        <div className="flex flex-col gap-2 lg:flex-row lg:items-center lg:gap-2">
          <div className="flex-1 min-w-0 lg:flex-[2]">
            <ChapterSelect {...chapterSelectProps} />
          </div>
          <AfricanOnlyInput
            variant="inline"
            className="lg:w-auto lg:flex-none"
          />
        </div>
      )}
      <SentenceCard
        {...{
          idx,
          language,
        }}
      />
    </div>
  );
}

export default SentencesDisplay;
